export enum OfferingServiceFrequencyEnum {
  Unknown = 0,
  Hourly = 10,
  Daily = 20,
  Weekly = 30,
  Monthly = 40,
  OneTime = 100
}
